var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoachingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 35,
    viewBox: "0 0 64 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1962 22.0037C40.831 20.508 36.6891 19.415 32.0007 19.415C27.3124 19.415 23.1705 20.5368 19.8052 22.0037C16.6988 23.3843 14.7429 26.4907 14.7429 29.8848V31.6393C14.7429 33.2213 16.0373 34.5156 17.6192 34.5156H46.3822C47.9642 34.5156 49.2585 33.2213 49.2585 31.6393V29.8848C49.2585 26.4907 47.3026 23.3843 44.1962 22.0037Z",
    fill: "#DA3273"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50176 24.6786C1.3733 25.599 -0.00732422 27.67 -0.00732422 29.9998V31.6393C-0.00732422 33.2212 1.28701 34.5156 2.86898 34.5156H12.936V29.8847C12.936 27.4974 13.5976 25.2539 14.7481 23.298C13.6839 23.1254 12.6196 23.0104 11.4979 23.0104C8.65034 23.0104 5.94662 23.6144 3.50176 24.6786Z",
    fill: "#DA3273"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.491 24.6786C58.0461 23.6144 55.3424 23.0104 52.4948 23.0104C51.3731 23.0104 50.3089 23.1254 49.2446 23.298C50.3951 25.2539 51.0567 27.4974 51.0567 29.8847V34.5156H61.1237C62.7057 34.5156 64 33.2212 64 31.6393V29.9998C64 27.67 62.6194 25.599 60.491 24.6786Z",
    fill: "#DA3273"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0007 17.2578C36.7754 17.2578 40.6296 13.4036 40.6296 8.6289C40.6296 3.85424 36.7754 0 32.0007 0C27.2261 0 23.3718 3.85424 23.3718 8.6289C23.3718 13.4036 27.2261 17.2578 32.0007 17.2578Z",
    fill: "#DA3273"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4976 7.18183L4.29785 14.3816L11.4976 21.5814L18.6974 14.3816L11.4976 7.18183Z",
    fill: "#DA3273"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4954 8.62891L45.3047 20.1341H59.6862L52.4954 8.62891Z",
    fill: "#DA3273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachingIcon);
export default __webpack_public_path__ + "static/media/coaching-icon.6c4f6cf0.svg";
export { ForwardRef as ReactComponent };